global.__rootdir__ = __dirname || process.cwd();
